// import React, { Component } from "react";
import MaterialPack from "./materialPack";

// let currrentOpened = -1;
// let tabsOpenStatus = [];

// class AllMaterialPack extends Component {
// 	state = {
// 		iconFolder: "img",

// 		isOpenedId: -1,
// 	};

// 	handleCollapse = (id) => {
// 		if (currrentOpened == id) {
// 			tabsOpenStatus[id] = false;
// 			currrentOpened = -1;
// 		} else if (currrentOpened == -1) {
// 			tabsOpenStatus[id] = true;
// 			currrentOpened = id;
// 		} else {
// 			tabsOpenStatus[id] = true;
// 			tabsOpenStatus[currrentOpened] = false;

// 			currrentOpened = id;
// 		}

// 		this.setState({ isOpenedId: currrentOpened });
// 	};

// 	handleOpenStatus = (id) => {
// 		tabsOpenStatus[id] = false;
// 		return false;
// 	};

// 	findRoomData = (obj, roomId) => {
// 		for (const key in obj) {
// 			if (obj[key].roomId == roomId) {
// 				return obj[key];
// 			}
// 		}
// 	};

// 	render() {
// 		let { handleUEcmd, changeObj, roomIndex, roomData } = this.props;
// 		if (roomData && changeObj) {
// 			let iconFolder = this.state.iconFolder;
// 			let roomOptions = roomData.options;

// 			return roomOptions.map((pack, id) => (
// 				<MaterialPack
// 					key={id}
// 					id={id}
// 					changeObj={changeObj.changeObj[roomIndex].selectedChoice[id]}
// 					icon={iconFolder + "/" + pack.icon}
// 					name={pack.label.de}
// 					isOpened={tabsOpenStatus[id]}
// 					collapseHandle={this.handleCollapse}
// 					choices={pack.choices}
// 					matBtnCMD={handleUEcmd}
// 					objectName={pack.unreal_id}
// 				/>
// 			));
// 		} else {
// 			return <div></div>;
// 		}
// 	}
// }

// export default AllMaterialPack;

import React, { useState } from "react";

let currrentOpened = -1;
let tabsOpenStatus = [];

function AllMaterialPack(props) {
	let { handleUEcmd, changeObj, roomIndex, roomData } = props;
	const [isOpenedId, setIsOpenedId] = useState(-1);

	function handleCollapse(id) {
		if (currrentOpened == id) {
			tabsOpenStatus[id] = false;
			currrentOpened = -1;
		} else if (currrentOpened == -1) {
			tabsOpenStatus[id] = true;
			currrentOpened = id;
		} else {
			tabsOpenStatus[id] = true;
			tabsOpenStatus[currrentOpened] = false;

			currrentOpened = id;
		}

		setIsOpenedId(currrentOpened);
	}

	function handleOpenStatus(id) {
		tabsOpenStatus[id] = false;
		return false;
	}

	function findRoomData(obj, roomId) {
		for (const key in obj) {
			if (obj[key].roomId == roomId) {
				return obj[key];
			}
		}
	}

	if (roomData && changeObj) {
		let roomOptions = roomData.options;

		return roomOptions.map((pack, id) => (
			<MaterialPack
				key={id}
				id={id}
				changeObj={changeObj.changeObj[roomIndex].selectedChoice[id]}
				name={pack.label.de}
				isOpened={tabsOpenStatus[id]}
				collapseHandle={handleCollapse}
				choices={pack.choices}
				matBtnCMD={handleUEcmd}
				objectName={pack.unreal_id}
			/>
		));
	} else {
		return <div></div>;
	}
}
export default AllMaterialPack;
